export default {"src":"/inst/_next/static/media/logo-pet-anjo.b40cd68c.svg","height":20,"width":67,"blurWidth":0,"blurHeight":0};